import constants from '../../../constants';

const filtersOptions = [
  { menuSelector: constants.statusBilling.estimate.name, value: constants.statusBilling.estimate.value },
  { menuSelector: constants.statusBilling.computed.name, value: constants.statusBilling.computed.value },
  { menuSelector: constants.statusBilling.ordered.name, value: constants.statusBilling.ordered.value },
];

export default filtersOptions;
